<po-page-default>
  <app-welcome></app-welcome>
  <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12 selling-products">
    <span class="po-font-text po-clickable back-page" (click)="backHome()">Voltar</span>
    <po-widget>
      <div class="po-row">
        <div class="po-xl-7 po-lg-7 po-md-7 po-sm-7 po-pt-0">
          <span class="po-font-text-bold ">Registro de Vendas - {{boughtRecently ? 'Clientes que compraram nos ultimos 90 dias' : 'Clientes que não compram a 90 dias'}}</span>
        </div>
      </div>
      <div class="po-row po-p-1 po-mt-1" style="border: 1.5px solid #DFE2E7; border-radius: 5px;"
        *ngFor="let item of customers; let i = index">
        <div class="po-xl-11 po-lg-11 po-md-11 po-sm-11 po-mb-1">
          <span style="font-size: 18px; color: #38acc9; font-weight: 500;">{{item.personName}}</span>
        </div>
        <div class="po-xl-1 po-lg-1 po-md-1 po-sm-1" style="text-align: end;">
          <span style="font-size: 18px; color: #2290AC; cursor: pointer;" class="po-icon po-icon-arrow-down"
            (click)="clickView(item.personCode)"></span>
        </div>
        <div class="po-row">
          <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12">
            <b>Telefone: </b> <span>{{item.personPhone}}</span>
            <b>
              <span id="waIcon" style="font-size: 20px;"
                class="po-icon po-icon-social-whatsapp po-ml-1 po-mb-1 pointer-cursor"
                p-tooltip="Enviar mensagem pelo Whasapp" (click)="sendWa(item.personPhone)"></span>
              <span id="copyIcon" style="font-size: 20px;" class="po-icon po-icon-copy pointer-cursor po-ml-1"
                p-tooltip="Copiar contato" (click)="copyContact(item.personPhone)"></span>
            </b>
            <b style="margin-left: 20px;">Última compra:</b> <span>{{item.lastPurchaseDate | date:'dd/MM/yyyy'}}</span>
          </div>
          <div *ngIf="item.totalGrossValue && item.totalQuantity" class="po-xl-12 po-lg-12 po-md-12 po-sm-12">
            <b>Valor Total: </b> <span>{{item.totalGrossValue}}</span>
            <b style="margin-left: 20px;">Quantidade:</b> <span>{{item.totalQuantity}}</span>
          </div>
        </div>
        <div id="{{item.personCode}}" class="po-row po-p-1 po-mt-1 invisivel"
          style="border: 1.5px solid #DFE2E7; border-radius: 5px; overflow-x: auto;">
          <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12" style="min-width: 600px;">
            <po-table [p-items]="item.items"></po-table>
          </div>
        </div>
      </div>
    </po-widget>
  </div>
</po-page-default>